module.exports = __webpack_public_path__ + "img/UVC5.e5690c9e.png";